import { render, staticRenderFns } from "./UsageCard.vue?vue&type=template&id=30a72891&scoped=true&"
import script from "./UsageCard.vue?vue&type=script&lang=ts&"
export * from "./UsageCard.vue?vue&type=script&lang=ts&"
import style0 from "./UsageCard.vue?vue&type=style&index=0&id=30a72891&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a72891",
  null
  
)

export default component.exports